import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchApiData } from "../../../store/slicers/apiSlicer.js";
import "../../styles/briefs.css";

const BriefsQuick = () => {
  const dispatch = useDispatch();
  const [briefs, setBriefs] = useState([]);

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.briefsRecent,
    isLoading: state.apiData?.loading?.briefsRecent
  }));

  useEffect(() => {
    dispatch(fetchApiData({ url: 'brief/recent?limit=5', itemKey: 'briefsRecent' }));
  }, [dispatch]);

  useEffect(() => {
    if (data?.data) {
      setBriefs(data.data.slice(0, 3));
    }
  }, [data]);

  const truncateContent = (text, maxLength = 200) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  if (isLoading) return <p className="loading">Chargement des brèves...</p>;

  return (
    <div className="briefs-card">
      <h3 className="briefs-header">
        <i className="pi pi-newspaper"></i> Dernières Brèves
      </h3>
      {briefs.map((brief) => (
        <div key={brief.id} className="brief-item">
          <h4 className="brief-item-title">{brief.title}</h4>
          <p className="brief-item-content">{truncateContent(brief.content)}</p>
        </div>
      ))}
      <Link to="/breves" className="see-more">
        Voir plus
      </Link>
    </div>
  );
};

export default BriefsQuick;
